import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import ContentStore from 'stores/Content.store';
import styles from './PlannedEvents.module.scss';
import { Container, Title } from 'common/components/Layout/Layout';
import UpcomingEvents from 'common/components/UpcomingEvents/UpcomingEvents';
import PrimaryButtonComponent from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent';
import { when } from 'mobx';
import messages from './PlannedEvents.intl';
import ReturnToInvestors from '../../common/components/ReturnToInvestors/ReturnToInvestors';

@injectIntl
@observer
export default class ForInvestors extends Component {
  pageSize = 5;

  state = {
    upcomingEventData: [],
    displayedEvents: [],
    currentPage: 1
  };

  fetchContent = async () => {};

  componentDidMount() {
    when(
      () => ContentStore.isLoaded,
      () => {
        const { content } = ContentStore;
        const { ForInvestors: upcomingEventData } = content;
        this.setState({
          upcomingEventData,
          displayedEvents: upcomingEventData.slice(0, this.pageSize)
        });
      }
    );
  }

  readMoreEvents = () => {
    const { currentPage, upcomingEventData, displayedEvents } = this.state;
    const startSlicePoint = currentPage * this.pageSize;
    const additionalItems = upcomingEventData.slice(
      startSlicePoint,
      startSlicePoint + this.pageSize
    );
    displayedEvents.push(...additionalItems);
    this.setState({
      currentPage: currentPage + 1
    });
  };

  render() {
    const { currentPage, displayedEvents, upcomingEventData } = this.state;
    const displayButtonMoreEvents =
      currentPage * this.pageSize < upcomingEventData.length;
    return (
      <>
        <Container>
          <Title title={this.props.intl.formatMessage(messages.title)} />
        </Container>
        <Container>
          <ReturnToInvestors />
        </Container>
        <Container>
          <div className={styles.EventsWrapper}>
            <UpcomingEvents upcomingEventData={displayedEvents} />
            {displayButtonMoreEvents && (
              <PrimaryButtonComponent
                text={this.props.intl.formatMessage(messages.eventsButton)}
                onClick={this.readMoreEvents}
              />
            )}
          </div>
        </Container>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/PlannedEvents/PlannedEvents.js